<template>
    <div class="login">
        <div class="columns">
            <div class='column is-4 is-offset-4'>
                <transition name="fade">
                    <div v-if="resendSuccess" class="notification is-info">
                        <button class="delete" @click="closeResendSuccess"></button>
                        <p v-if="this.picked == 'email'">We have resent the verification code to {{vendor.email}}.
                        </p>
                        <p v-else-if="this.picked == 'cell_phone'">We have resent the verification code to {{vendor.cell_phone}}.
                        </p>
                    </div>
                </transition>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <form>
                    <div class='column is-horizontal-center'>
                          <figure class='image'>
                            <img src="../../assets/images/excel-logo-full.png">
                        </figure>
                    </div>
                    <!-- start invalid token and id -->
                    <div v-if="emptyTokenError">
                        <div class="password-reset">
                            <p><img src="../../assets/images/error.png" style="margin-bottom: 16px;"></p>
                            <p><strong>Page Not Found.</strong></p>
                        </div>
                    </div>
                    <!-- end invalid token and id -->
                    <!-- start invalid token and id -->
                    <div v-else-if="invalidTokenError">
                        <div class="password-reset">
                            <p><img src="../../assets/images/error.png" style="margin-bottom: 16px;"></p>
                            <p class="reset-heading">Token Expired</p>
                            <p>Please use link found in email to create account.</p>
                            <p>Or <span class="resend" @click="sendLogin">login</span> if you have created an account.</p>
                        </div>
                    </div>
                    <!-- end invalid token and id -->
                    <!-- start valid token and id -->
                    <div v-if="validToken">
                        <div class="password-reset">
                            <p class="reset-heading">Account Sign Up</p>
                            <p>Hello <strong>{{ vendor.first_name }}</strong>, in order to sign up for an account, we want to make sure it's really you. To further verify your identity, select a method to receive your verification code. When you receive your code, enter it in the next step.</p>
                        </div>
                        <div class="field" style="margin-top: 25px;">
                            <input type="radio" id="email" value="email" v-model="picked" @click="enableSend" class="radio-field"/>
                            <label for="email">{{ vendor.email }}</label>
                        </div>
                        <div class="field" style="">
                            <input type="radio" id="cell_phone" value="cell_phone" v-model="picked" @click="enableSend" class="radio-field"/>
                            <label for="cell_phone">{{ vendor.cell_phone }}</label>
                        </div>
                        <div class="field" style="margin-top: 25px;">
                            <button @click.prevent="sendCode" class="button is-link login-link" :disabled="! canSend" v-bind:class="{ 'is-loading': isLoading}">Send Code</button>
                        </div>
                    </div>
                    <!-- end valid token and id -->
                    <!-- start enter verification code -->
                    <div v-if="retrieveSecret">
                        <div class="password-reset">
                            <!-- <p><img src="../../assets/images/success.png" style="margin-bottom: 16px;"></p> -->
                            <p class="reset-heading">Enter Verification Code</p>
                            <p v-if="this.picked == 'email'">A verification code has been sent to {{vendor.email}}.
                            </p>
                            <p v-else-if="this.picked == 'cell_phone'">A verification code has been sent to {{vendor.cell_phone}}.
                            </p>
                        </div>
                        <div class="field" style="margin-top: 25px;">
                            <div class="control has-icons-left">
                                <input class="input is-medium" v-bind:class="{ 'is-danger': incorrectSecret }" type="text" placeholder="Verification Code" @input="enableVerify" v-model="secretCode">
                                <span class="icon is-small is-left">
                                    <icon name="user"></icon>
                                </span>
                            </div>
                            <p v-if="incorrectSecret" class="help is-danger is-danger-username">Invalid verification code.</p>
                        </div>
                        <div class="field password-reset" style="margin-top: 25px;">
                            <button @click.prevent="verifyCode" class="button is-link login-link" :disabled="! canVerify" v-bind:class="{ 'is-loading': verifyCodeLoader}">Verify</button>
                            <p>Didn't receive your code? <span class="resend" @click="resendCode">Resend code</span>.</p>
                        </div>
                    </div>
                    <!-- end enter verification code -->
                    <!-- start verification code successful -->
                    <div v-if="secretConfirm">
                        <div class="password-reset">
                            <p><img src="../../assets/images/success.png" style="margin-bottom: 16px;"></p>
                            <p class="reset-heading">Successfully Verified</p>
                        </div>
                        <div>
                            <p>Your account with username <strong>{{userName}}</strong> has been created. Password must be 8 characters or more with one capital letter, one number and one special character.
                            </p>
                            <br/>
                        </div>
                        <div class="field">
                            <label>Password</label>
                            <div class="control has-icons-left">
                                <input class="input is-medium" v-bind:class="{ 'is-danger': passwordErr }" type="password" placeholder="Password" v-model="password" @focus="clearErrorMsgs" @keyup="checkPassWord($event.target.value)" @blur="checkPassWord($event.target.value)">
                                <span class="icon is-small is-left">
                                    <icon name="key"></icon>
                                </span>
                            </div>
                            <p v-if="passwordErr" class="help is-danger is-danger-password">Password is required</p>
                            <p v-if="passwordCharLengthError" class="help is-danger is-danger-password">Minimum 8 characters, one capital letter, one number and one special character.</p>
                        </div>
                        <div class="field" style="margin-top: 25px;">
                            <label>Confirm Password</label>
                            <div class="control has-icons-left">
                                <input class="input is-medium" v-bind:class="{ 'is-danger': confirmPasswordErr }" type="password" placeholder="Confirm Password" v-model="confirmPassword" @focus="clearErrorMsgs" @keyup="checkValue($event.target.value)" @blur="checkValue($event.target.value)">
                                <span class="icon is-small is-left">
                                    <icon name="key"></icon>
                                </span>
                            </div>
                            <p v-show="confirmPasswordErr" class="help is-danger is-danger-password"><img width="20" src="../../assets/images/error.png"/> Password do not match</p>
                            <p v-show="passwordMatch" class="help is-success"><img width="20" src="../../assets/images/success.png"/> Matched</p>
                        </div>
                        <div class="field" style="margin-top: 25px;">
                            <button @click.prevent="savePassword" class="button is-link login-link" v-bind:class="{ 'is-loading': isLoading}" :disabled="! canSavePassword">Save</button>
                        </div>
                    </div>
                    <!-- end verification code successful -->
                </form>
            </div>
        </div>

    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    data () {
        return {
            picked: '',
            secretCode: '',
            canSend: false,
            canVerify: false,
            fieldRequired: false,
            ifCodeError: false,
            password: '',
            confirmPassword: '',
            passwordMatch: false,
            passwordErr: false,
            confirmPasswordErr: false,
            canSavePassword: false,
            passwordCharLengthError: false,   //Minimum 6 characters, One capital letter, Special character, Number
        }
    },

    computed: {
        ...mapState('user', {
            emptyTokenError: state => state.emptyTokenError,
            invalidTokenError: state => state.invalidTokenError,
            validToken: state => state.validToken,
            retrieveSecret: state => state.retrieveSecret,
            secretConfirm: state => state.secretConfirm,
            incorrectSecret: state => state.incorrectSecret,
            isLoading: state => state.sendCodeLoader,
            verifyCodeLoader: state => state.verifyCodeLoader,
        }),

        ...mapGetters('user', {
            vendor: 'getvendor',
            resetToken: 'getresetToken',
            token: 'gettoken',
            userName: 'getuserName',
            resendSuccess: 'getresendSuccess',
        }),

        ...mapState('passwordReset', {
            isLoading: state => state.isLoading,
            resetPasswordErrMessage: state => state.resetPasswordErrMessage,
        })
    },

    methods: {
        savePassword(){
            VueStore.dispatch('passwordReset/setBoolean', {key: 'isLoading', bool: true});
            var password = {
                password: this.password,
                token: this.resetToken
            }

            VueStore.dispatch('passwordReset/savePassword', password);
        },

        checkValue(val){
            if(this.password == ''){
                this.passwordErr = true;
            } else if(this.password === val){
                this.passwordMatch = true;
                this.canSavePassword = true;
                this.confirmPasswordErr = false;
            } else {
                this.confirmPasswordErr = true;
                this.passwordMatch = false;
                this.canSavePassword = false;
            }
        },

        checkPassWord(val){
            //console.log(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/.test(val));
            if(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(val) == false ){
                this.passwordCharLengthError = true;
            } else {
                this.passwordCharLengthError = false;
            }
        },

        verifyCode(){
            VueStore.dispatch('user/setVariable', {key: 'sendCodeLoader', value: true});
            //
            VueStore.dispatch('user/verifyCode', this.secretCode); 
        },
        sendCode(){
            //send code loader
            VueStore.dispatch('user/setVariable', {key: 'sendCodeLoader', value: true});
            //
            VueStore.dispatch('user/sendCode', this.picked); 
        },

        resendCode(){
            VueStore.dispatch('user/setVariable', {key: 'incorrectSecret', value: false});
            VueStore.dispatch('user/setVariable', {key: 'resendClicked', value: true});
            this.secretCode = '';
            this.canVerify = false;
            VueStore.dispatch('user/sendCode', this.picked); 
        },

        closeResendSuccess(){
            VueStore.dispatch('user/setVariable', {key: 'resendSuccess', value: false});
        },

        enableSend(){
            this.canSend = true
        },

        enableVerify(){
            this.canVerify = true
        },

        fetchData(){
            // this will save the url of client
            VueStore.dispatch('global/getBaseURL');
        },
        processURL(){
            var url_string = window.location.href;
            var url = new URL(url_string);
            var token = url.searchParams.get("token");
            var id = url.searchParams.get("id");

            if(token !== null && id !== null){
                var data = {
                    token: token,
                    id: id
                }

                // delay so auth store is loaded.
                setTimeout(function(){ 
                    VueStore.dispatch('user/checkToken', data).then(
                    (response) => {
                    })
                }, 500);
            } else {
                //console.log("else")
                // show invalid
                VueStore.dispatch('user/setVariable', {key: 'emptyTokenError', value: true}); 
            }
        },

        sendLogin(){
            window.location.href = '/login';
        },

        clearErrorMsgs(){
            this.passwordErr = false;
            this.confirmPasswordErr = false;
        },
    },

    mounted(){
        this.processURL();
        // retrive environment variables and stored in vuex.
        VueStore.dispatch('auth/setVariables');
    }
}
</script>

<style scss>
.reset-heading{
    font-size: 16px;
    color: #4a4a4a !important;
    margin-bottom: 8px;
}

.radio-list {
  .radio {
    display: block;

    & + .radio {
      margin-left: 0;
      margin-top: .5em;
    }
  }
}

.login label {
    margin-top: 0px !important;
}

.radio-field{
    cursor: pointer;
}

.resend{
    border-bottom: 1px dotted;
    cursor: pointer;
    white-space: nowrap;
}

.resend:hover{
    color: #3273dc;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter-from, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>
